// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const members = {
  getMembers(page,search,sort_date) {
    return AuthService.get(`membership/members?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&search=${search}`
    );
  },
  showMembers(id) {
    return AuthService.get(`membership/members/${id}`);
  },
  createMembers(data) {
    return AuthService.post("membership/members", data);
  },
  updateMembers(id, data) {
    return AuthService.put(`membership/members/${id}`, data);
  },
  deleteMembers(id) {
    return AuthService.delete(`membership/members/${id}`);
  },
  getMemberTopicType() {
    return AuthService.get(`membership/member-topic-type`);
  }
};
export default members;
